export default "__VITE_ASSET__0lgKP$9U__";